export default function sortAlphanumerically(a, b) {
  if (a && b) {
    return `${a}`.localeCompare(`${b}`, 'en', { numeric: true });
  }
  return a > b ? 1 : -1;
}
